export const USER_ID_SALT = 'course!~849302a4848dsawb3';

export const FACEBOOK_APP_ID = '823425307723964';

export const TWITTER_SOURCE_PARAM = 'tw';

export const FACEBOOK_SOURCE_PARAM = 'fb';

export const EMAIL_SOURCE_PARAM = 'email';

export const LINKEDIN_SOURCE_PARAM = 'ln';

export const WHATSAPP_SOURCE_PARAM = 'wa';

export const COPYLINK_SOURCE_PARAM = 'link';

export const NATIVE_MOBILE_SOURCE_PARAM = 'mobile';

export const CUSTOM_URL_ENDPOINT = 'api/customUrls.v1';

export const SHARE_QUERY_PARAM = 'action=share';
